var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logos",attrs:{"src":require("../../../../../style/image/logomap.png"),"alt":"logo"},on:{"click":_vm.onLinkHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }